<script>
    import { resetPasswordByHash } from '/public/services/users/users';
    export let user;
    export let hash;
    import { InfoCircle, ExclamationTriangle } from 'svelte-bootstrap-icons';
    import { Eye, EyeSlash } from "svelte-bootstrap-icons";
    import PasswordComplexity from '/core/components/users/PasswordComplexity.svelte';

    let password = {
        password: null,
        password_confirmation: null
    }

    let passwordMismatch = false;
    let successfulReset = false;
    let showPassword = false;

    let passwordOK = false;   

    function processPasswordReset(e) {
        e.preventDefault();

        passwordMismatch = false;

        if (password.password != password.password_confirmation) {
            passwordMismatch = true;
            return;
        }

        resetPasswordByHash(hash, password).then(res => {
            if (res.success) {
                successfulReset = true;
            }
        });
    }

    function passwordComplexityEvent(evt) {
        passwordOK = evt.detail;
    }

    function resetMismatch() {
        passwordMismatch = false;
    }

</script>


<div class="">

    {#if successfulReset === false}

        <div class='mb-5 text-center'>
            Hi {user.first}, you can reset your password
        </div>

        <form on:submit={processPasswordReset} class='mb-5'>            
            <div class="row mb-3">                
                <div class="">
                    <div class='input-group mb-3'>
                        <div class="form-floating">

                            {#if showPassword === false}

                                <input 
                                    id="password-one" 
                                    type="password" 
                                    class="form-control" 
                                    required 
                                    bind:value={password.password} 
                                    minlength="8" 
                                    placeholder="New Password"                                    
                                />

                            {:else}

                                <input 
                                    id="password-one" 
                                    type="text" 
                                    class="form-control" 
                                    required 
                                    bind:value={password.password} 
                                    minlength="8" 
                                    placeholder="New Password"                                    
                                />

                            {/if}

                            <label for="password=one">
                                Password
                            </label>

                        </div>

                        <span class='input-group-text'>                                

                            <span 
                                class='js-button fas'                                    
                                on:click={() => showPassword = ! showPassword}
                                on:keypress={() => showPassword = ! showPassword}
                                role='button'
                                tabindex='0'
                            >

                                {#if showPassword === false}

                                    <Eye/>

                                {:else}

                                    <EyeSlash/>

                                {/if}

                            </span>
                        </span>                        
                    </div>
                </div>
            </div>
            <div class="row mb-3">                
                <div class="">
                    <div class='input-group'>
                        <div class="form-floating">
                        
                            {#if showPassword === false}

                                <input 
                                    on:keypress={resetMismatch} 
                                    id="password-two" 
                                    type="password" 
                                    class="form-control" 
                                    required 
                                    bind:value={password.password_confirmation} 
                                    minlength="8" 
                                    placeholder="And again"
                                />

                            {:else}

                                <input 
                                    on:keypress={resetMismatch} 
                                    id="password-two" 
                                    type="text" 
                                    class="form-control" 
                                    required 
                                    bind:value={password.password_confirmation} 
                                    minlength="8" 
                                    placeholder="And again"
                                />


                            {/if}

                            <label for="password-two">
                                Confirm password
                            </label>

                        </div>

                        <span class='input-group-text'>                                

                            <span 
                                class='js-button fas'                                    
                                on:click={() => showPassword = ! showPassword}
                                on:keypress={() => showPassword = ! showPassword}
                                role='button'
                                tabindex='0'
                            >

                                {#if showPassword === false}

                                    <Eye/>

                                {:else}

                                    <EyeSlash/>

                                {/if}

                            </span>
                        </span>

                    </div>
                </div>
            </div>

            {#if passwordMismatch === true}

                <div class="alert alert-warning mb-3 p-3">
                    <ExclamationTriangle/> Your passwords do not match!
                </div>

            {/if}

            <div class='text-center mb-3'>
                <small>

                    {#key password.password}

                        <PasswordComplexity
                            password={password.password}
                            on:complexity={passwordComplexityEvent}
                        />

                    {/key}

                </small>

            </div>

            <div class="">
                <div class="d-grid">
                    <button type="submit" class="btn btn-primary btn-lg" disabled={passwordOK === false}>
                        Reset password
                    </button>
                </div>
            </div>
        </form>

    {:else}

        <div class="alert alert-secondary mt-5 mb-5 p-3 text-center">
            Your password has been reset.
            <br/>
            Click below to log in to your account.            
            <div class="text-center mt-5 mb-3">
                <a href="/" class="btn btn-primary">
                    Login
                </a>
            </div>
        </div>

    {/if}
</div>
